import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)
    
    return (
        <svg
            width={59}
            height={58}
            viewBox="0 0 59 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.666016} width={58} height={58} rx={29} fill={props.isHover ? theme["#0D968F"] : "#F7FEFD"} />
        <path
            d="M25.167 29c0-.663.148-1.293.41-1.863.204-.441.169-.978-.175-1.321l-2.577-2.577c-.41-.41-1.086-.389-1.417.087A9.904 9.904 0 0019.637 29c0 2.104.65 4.059 1.762 5.67.33.478 1.008.5 1.419.09l2.583-2.576c.344-.343.38-.88.176-1.322-.263-.57-.41-1.2-.41-1.862zM29.667 24.5c.663 0 1.293.148 1.863.41.441.204.978.17 1.321-.174l2.55-2.55c.409-.409.388-1.083-.086-1.415A9.883 9.883 0 0029.637 19a9.91 9.91 0 00-5.66 1.762c-.478.33-.501 1.008-.09 1.42l2.56 2.567c.346.347.888.38 1.332.172a4.437 4.437 0 011.888-.421zM37.556 22.906a.48.48 0 00-.72-.036l-3.219 3.21a.54.54 0 00-.07.656 4.456 4.456 0 010 4.529.54.54 0 00.07.655l3.219 3.22a.48.48 0 00.72-.037A9.945 9.945 0 0039.637 29a9.913 9.913 0 00-2.08-6.094zM29.665 33.5a4.456 4.456 0 01-2.264-.62.54.54 0 00-.656.07l-3.25 3.25a.48.48 0 00.037.72A9.945 9.945 0 0029.635 39a9.872 9.872 0 006.108-2.09.48.48 0 00.034-.718l-3.225-3.225a.54.54 0 00-.65-.071 4.458 4.458 0 01-2.237.604z"
            fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]}
        />
        </svg>
    )
}

export default SvgComponent